export default __webpack_public_path__ + "static/media/glb_file_icon.76ace176.svg";